import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	emptyFieldValue: {
		id: 'polaris-ideas.view-controls.common.field-values.goals.empty-field-value',
		defaultMessage: 'No value',
		description: 'Header for the "empty" columns',
	},
});
